import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-iconbutton',
  templateUrl: './iconbutton.component.html',
  styleUrls: ['./iconbutton.component.scss']
})
export class IconbuttonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
